import React, { useState, useContext, useEffect } from 'react'
import { Popover } from '@material-ui/core'
import { ArrowDropUp, ArrowDropDown, FilterList, ExpandMore } from '@material-ui/icons'
import listContext from '../../../Common/context/context'
import allColumns from '../propertyListColumns'
import { sortPropertyList, updatePropertyRank, getSummaryColumnsList } from '../../Utility/PropertyListUtility'

const SortPropertyListTable = () => {

    const [anchorEl, setAnchorEl] = useState(null)
    const { propertyList, setPropertyList } = useContext(listContext)
    const [sort, setSort] = useState({ field: '', order: '' })
    const [sortFields, setSortFields] = useState([])

    useEffect(() => {
        if (propertyList) {
            setSortFields(getColumnsList())
        }
    }, [propertyList])

    // const getColumnsList = () => {

    //     let forColumns = []
    //     const compType = propertyList.compType ? propertyList.compType.toLowerCase() : 'rent'
    //     if (compType === 'rent') {
    //         forColumns = getRentViewSettings(propertyList)
    //     } else {
    //         forColumns.push(compType)
    //     }
    //     if (forColumns.length === 0) {
    //         forColumns.push('market rent')
    //     }
    //     return allColumns.filter(col => col.sortable && col.for.some(r => forColumns.indexOf(r) >= 0))
    // }

    const getColumnsList = () => {

        try {
            let newColumnList = getSummaryColumnsList(propertyList, allColumns)

            return newColumnList.filter(col => col.sortable)
        } catch (error) {
            console.log('error in getColumnsList ', error)
            return []
        }

    }

    const handleShowOptions = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)

    const handleSort = sortField => {
        let order = 'desc'

        if (sort.field === sortField.fieldName) {
            order = sort.order === 'desc' ? 'asc' : 'desc'
        }

        setSort({ field: sortField.fieldName, order })

        let newPropertyList = { ...propertyList }

        newPropertyList = { ...sortPropertyList(newPropertyList, sortField, order) }

        setPropertyList(newPropertyList)

        updatePropertyRank(newPropertyList)

        handleClose()
    }

    const getSortByLabel = () => {
        let returnVal = sortFields.filter(x => x.fieldName === sort.field)
        return returnVal.length > 0 ? `: ${returnVal[0].label} -- ${sort.order === 'desc' ? 'High to Low' : 'Low to High'}` : ''
    }


    return (
        <>
            <button data-testid="test-btn-show-list-options" className={`btn btn-sm border-1 border-base ${sort.field !== '' ? 'bg-gray-20' : ''}`} onClick={handleShowOptions}>
                <FilterList fontSize="small" />
                <span className="px-4" >Sort by {getSortByLabel()}</span>
                <ExpandMore fontSize="small" />
            </button>
            <Popover onClose={handleClose} open={open} anchorEl={anchorEl} data-testid="test-propertylist-sort-options"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                transformOrigin={{ vertical: 'top', horizontal: 'left', }} >
                <div className="flex flex-col text-2">
                    {sortFields.map(sortField => (
                        <div >
                            <div data-testid={`test-sort-by-${sortField.fieldName}`} onClick={() => { handleSort(sortField) }} role="button"
                                className="p-4 flex flex-row justify-between space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                                <div className="">
                                    {sortField.label}
                                </div>
                                <div>
                                    {sort.field === sortField.fieldName && sort.order !== 'asc' ?
                                        <ArrowDropUp fontSize="small" />
                                        : <ArrowDropDown fontSize="small" />}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Popover>
        </>
    )
}


export default SortPropertyListTable
